import React, { useEffect } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import './style.css'
import NavBar from '../common/navbar'
import { useSelector, useDispatch } from 'react-redux'
import { Actions } from '../../store/actions'
import Form from 'react-bootstrap/Form'
import Dropdown from 'react-bootstrap/Dropdown'
import EcoCenters from '../EcoCenters'

function EditUser(props) {
    let isAuth = window.localStorage.getItem("isAuth") ? window.localStorage.getItem("isAuth") === "true" : window.sessionStorage.getItem("isAuth") === "true"
    let isAdmin = window.sessionStorage.getItem("isAdmin")
    let path = props.history.location.pathname
    let idOfUser = path.slice(path.lastIndexOf("/") + 1)
    let users = useSelector(state => state.usersList)
    let user = users.find(x => x.id === idOfUser)
    let pwd = "", confirmPwd = "", newUser = {
        ...user,
        password: ""
    }
    let dispatch = useDispatch()

    if (!isAdmin) {
        return (<Redirect to="/home" />)
    }

    if (!isAuth) {
        return (<Redirect to="/" />)
    }

    const handleChange = (e) => {
        e.currentTarget.id === "username" ?
            newUser.username = e.currentTarget.value :
            (e.currentTarget.id === "email" ?
                newUser.email = e.currentTarget.value :
                (e.currentTarget.id === "password" ?
                    newUser.password = e.currentTarget.value :
                    (e.currentTarget.id === "confirmPassword" ?
                        newUser.confirmPassword = e.currentTarget.value :
                        (e.currentTarget.id === "adminButton" ?
                            newUser.isAdmin = "true" :
                            newUser.isAdmin = "false"
                        )
                    )
                )
            )
    }
    const handleEcoCenterChange = (e) => {
        let selected = document.getElementById("dropdown-basic-eco-center");
        selected.innerText = e.target.innerText;
        newUser.EcoCenterSelected = e.target.innerText;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        newUser.Id = idOfUser;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...newUser })
        }

        let successMessage = document.getElementById("successUserEdit")
        let errorMessage = document.getElementById("errorUserEdit")

        if (newUser.EcoCenterSelected === "") {
            errorMessage.classList.remove("resultSpan");
            successMessage.classList.add("resultSpan");
            return;
        }

        if (newUser.password !== confirmPwd) {
            errorMessage.classList.remove("resultSpan")
            successMessage.classList.add("resultSpan")
            return;
        }

        await fetch("/EditUser", requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.status === "Success") {
                        successMessage.classList.remove("resultSpan")
                        errorMessage.classList.add("resultSpan")
                        let isStayIn = (window.localStorage.getItem("userId") && true) === true
                        let currentUserId = window.localStorage.getItem("userId") || window.sessionStorage.getItem("userId")
                        if (currentUserId === idOfUser) {
                            if (isStayIn) {
                                window.localStorage.setItem("isAdmin", newUser.isAdmin)
                            } else {
                                window.sessionStorage.setItem("isAdmin", newUser.isAdmin)
                            }
                            setTimeout(() => { props.history.push("/home") }, 1000)
                        } else {
                            setTimeout(() => { props.history.push("/users") }, 1000)
                        }
                    } else {
                        errorMessage.classList.remove("resultSpan")
                        successMessage.classList.add("resultSpan")
                    }
                },
                (error) => {
                    errorMessage.classList.remove("resultSpan")
                    successMessage.classList.add("resultSpan")
                }
            )
    }

    const usernameInput = <input className="inputSize form-control" id="username"
        aria-describedby="emailHelp" placeholder="Entrez utilisateur" defaultValue={user.username}
        onChange={handleChange} />

    const emailInput = <input type="email" className="inputSize form-control" id="email"
        aria-describedby="emailHelp" placeholder="Entrez e-mail" defaultValue={user.email}
        onChange={handleChange} />

    const passwordInput = <input type="password" className="inputSize form-control" id="password"
        placeholder="Mot de passe" defaultValue={pwd} onChange={handleChange} />

    const passwordConfirmInput = <input type="password" className="inputSize form-control" id="confirmPassword"
        placeholder="Confirmer le mot de passe" defaultValue={confirmPwd} onChange={handleChange} />

    let adminCheck = <Form.Check
        type="radio"
        id="adminButton"
        label="Administrateur"
        name="userType"
        onChange={handleChange}
        defaultChecked={user.isAdmin.toLowerCase() === "true"}
    />

    let userCheck = <Form.Check
        type="radio"
        label="Utilisateur"
        id="userButton"
        name="userType"
        onChange={handleChange}
        defaultChecked={user.isAdmin.toLowerCase() !== "true"}
    />

    const goBack = () => {
        window.sessionStorage.setItem("previousPage", props.history.location.pathname)
        props.history.push("/users")
    }
    let ecoCentersForDropdown = EcoCenters.slice();
    const ecoCenters = ecoCentersForDropdown.map((ecoCenter, index) =>
        <Dropdown.Item key={index} onClick={handleEcoCenterChange} value={ecoCenter.Id}>{ecoCenter.Name}</Dropdown.Item>
    )

    return (
        <div>
            <NavBar></NavBar>
            <button className="btn btn-primary margin-top-left" onClick={goBack}>Arrière</button>
            <form className="registrationForm editForm" onSubmit={handleSubmit}>
                <h1 className="header">Modifier l'utilisateur</h1>
                <div className="form-group inputSizeDiv">
                    {emailInput}
                </div>
                <div className="form-group inputSizeDiv">
                    {usernameInput}
                </div>
                <div className="form-group inputSizeDiv">
                    {passwordInput}
                </div>
                <div className="form-group inputSizeDiv">
                    {passwordConfirmInput}
                </div>
                <div className="mb-3">
                    {adminCheck}

                    {userCheck}
                </div> 
                <div className="form-group searchDiv" id="municipalityDiv">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic-eco-center">
                            {user.ecoCentre || "Écocentre"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                        {ecoCenters}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                    <button type="submit" className="submitButton btn btn-primary">Soumettre</button>
                <div className="munResultMainDiv">
                    <span className="alert alert-success resultSpan adaptiveSpan" id="successUserEdit" role="alert">
                        Succès!
                    </span>
                    <span className="alert alert-danger resultSpan adaptiveSpan" id="errorUserEdit" role="alert">
                        Error!
                    </span>
                </div>
            </form>
        </div>
    )
}

export default withRouter(EditUser)